<template>
  <LayoutSection :maxWidthClass="'max-w-[1100px] mx-auto'">
    <ViewAll :link="`/search/`" :title="$t('Outstanding profesionals')" />

    <div class="pt-[1.6rem]">
      <carousel
        :items-to-show="itemsToShow"
        :breakpoints="breakpoints"
        :snapAlign="snapAlign"
      >
        <slide class="item" v-for="(doctor, slide) in doctors" :key="slide">
          <DoctorInformation
            class="item w-full mx-2"
            :doctor="doctor"
            :homeDesign="true"
          />
        </slide>
      </carousel>
    </div>
  </LayoutSection>
</template>

<script>
import { defineComponent } from "vue";
import LayoutSection from "@/components/design/layoutSection.vue";
import DoctorInformation from "@/components/doctor/doctorInformation.vue";
import ViewAll from "@/components/buttons/viewAll.vue";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide } from "vue3-carousel";
import { fetchFeaturedDoctors } from "@/services/featuredDoctorsService";

export default defineComponent({
  name: "FeaturedDoctorsSection",
  components: {
    DoctorInformation,
    ViewAll,
    Carousel,
    Slide,
    LayoutSection,
  },
  data() {
    return {
      itemsToShow: 3,
      snapAlign: "start",
      breakpoints: {
        0: {
          itemsToShow: 1,
        },
        1024: {
          itemsToShow: 3,
        },
      },
      doctors: [],
    };
  },

  mounted() {
    this.getFeaturedDoctors();
  },

  methods: {
    async getFeaturedDoctors() {
      try {
        const doctors = await fetchFeaturedDoctors();
        this.doctors = Array.isArray(doctors) ? doctors : [];
      } catch {
        this.doctors = [];
      }
    },
  },
});
</script>

<style scoped></style>
